/**
 * short-url-constants.ts — Single source of truth for BitDrop short URL config.
 *
 * Shared between link-classifier.ts and short-url-resolver.ts.
 * Derived from the same ALPHABET and CODE_LENGTH as the link-shortener service
 * (apps/link-shortener/src/core/config.js) so both sides stay in sync.
 */

import { AppConfig } from '../../shared/config/app-config';

/** Canonical origin of the BitDrop link shortener service. */
export const SHORT_URL_ORIGIN = AppConfig.shareBaseUrl;

/** Short code length in characters — must match link-shortener CODE_LENGTH. */
export const SHORT_URL_CODE_LENGTH = 8;

/**
 * Valid characters for short codes — unambiguous alphabet matching the
 * server's ALPHABET constant (55 chars, no I/O/i/l/o/0/1).
 */
const SHORT_URL_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
const _escaped = SHORT_URL_ALPHABET.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

/**
 * Regex that matches a valid BitDrop short code.
 * Derived from ALPHABET and CODE_LENGTH — single source of truth.
 */
export const SHORT_URL_CODE_REGEX = new RegExp(
  `^[${_escaped}]{${SHORT_URL_CODE_LENGTH}}$`
);
